module.exports = __webpack_public_path__ + "img/fitness-xiaochengxucode.d2d712c1.png";